/* eslint-disable react/display-name */
import React from 'react';
import HeroTab from './HeroTab';
import ThetanBoxTab from './ThetanBoxTab';
import CosmeticTab from './CosmeticTab';
import GiftBoxTab from './GiftBoxTab';
import { CategoryKey } from './types';
export const categories = [{
  key: CategoryKey.Heroes,
  name: 'Heroes',
  renderCategory: () => /*#__PURE__*/React.createElement(HeroTab, null),
  dataTestId: 'heroes'
}, // Temporary disable to wait for update
// { key: CategoryKey.Pets, name: 'Pets', renderCategory: () => <PetTab /> },
{
  key: CategoryKey.ThetaBox,
  name: 'ThetanBox',
  renderCategory: () => /*#__PURE__*/React.createElement(ThetanBoxTab, null),
  dataTestId: 'thetan-boxes'
}, {
  key: CategoryKey.Cosmetic,
  name: 'Cosmetics',
  renderCategory: () => /*#__PURE__*/React.createElement(CosmeticTab, null),
  dataTestId: 'cosmetics'
}, {
  key: CategoryKey.GiftBox,
  name: 'Other Boxes',
  renderCategory: () => /*#__PURE__*/React.createElement(GiftBoxTab, null),
  dataTestId: 'other-boxes'
} // Temporary disable to wait for update
// {
//   key: CategoryKey.Others,
//   name: 'Others',
//   renderCategory: () => <OtherTab />,
// },
];